<template>

</template>

<script>
  import Vue from 'vue'
  import router from '@/router'
  import store from '@/store'
  import VueCookies from 'vue-cookies'

  Vue.use(VueCookies)

  export default {
    name: 'logout',
    mounted() {
      this.$cookies.remove(".jwt", "/")
      store.commit('LOGOUT_USER')
      router.push('login')
    }
  }
</script>



// WEBPACK FOOTER //
// src/auth/Logout.vue